import React from "react";
import {
  BrowserRouter,
  Routes as RouterRoutes,
  Route,
  Navigate,
} from "react-router-dom";

import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import PropertyHomepage from "./pages/property-homepage";

import ApartmentDetailSlug from "./pages/apartment-detail-view/ApartmentDetailSlug";
import RoomDetailSlug from "./pages/room-detail-view/RoomDetailSlug";

import ImageGalleryViewer from "./pages/image-gallery-viewer";
import ContactInquiryForm from "./pages/contact-inquiry-form";

const Routes = () => (
  <BrowserRouter>
    <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        <Route path="/" element={<PropertyHomepage />} />

        {/* Listings */}
        <Route path="/sobe" element={<PropertyHomepage />} />
        <Route path="/apartmani" element={<PropertyHomepage />} />

        {/* Details */}
        <Route path="/sobe/:slug" element={<RoomDetailSlug />} />
        <Route path="/apartmani/:slug" element={<ApartmentDetailSlug />} />

        {/* Legacy homepage redirect (optional) */}
        <Route
          path="/property-homepage"
          element={<Navigate to="/" replace />}
        />

        {/* Gallery + Contact */}
        <Route path="/image-gallery-viewer" element={<ImageGalleryViewer />} />
        <Route path="/contact-inquiry-form" element={<ContactInquiryForm />} />

        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
    </ErrorBoundary>
  </BrowserRouter>
);

export default Routes;
